<template>
  <el-dialog class="customDialog iconSelector" width="460px" title="图标选择" :visible.sync="isShow" :close-on-press-escape = 'false' :close-on-click-modal="false" @close="onClose">
    <div class="content">
      <el-radio-group v-model="iconGroup" class="header">
        <el-radio-button label="STEREO">立体</el-radio-button>
        <el-radio-button label="FLAT">扁平</el-radio-button>
        <el-radio-button label="PERSONAL">自定义</el-radio-button>
      </el-radio-group>
      <div class="icon-frame">
        <el-upload v-if="canUpload" v-show="iconGroup==='PERSONAL'" accept=".jpg,.png,.jpeg" action="" multiple :http-request='onUploadIcon' :on-success="handleSuccess" :before-upload = "beforeUpload" :show-file-list="false">
          <div class="add-btn">
            <svg width="1em" height="1em" fill="currentColor" aria-hidden="true">
              <use xlink:href="#icon-plus"></use>
            </svg>
          </div>
        </el-upload>
        <div v-for="item in groupIcons" :key="item.id" class="icon-item" :class="selectIconIndex === item.id?'active':''" @click="selectIconIndex=item.id">
          <div class="icon-image">
            <img :src="modulePath[item.module]+item.url" alt="">
          </div>
          <div class="del-icon" @click.stop="onRemoveIcon(item)" v-show="item.module==='PERSONAL'">
            <Icon name="icon-del" content="删除"></Icon>
          </div>
          <div class="check" v-if="selectIconIndex === item.id">
            <img src="~@/assets/images/xuanze.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <span slot="footer">
      <el-button type="default" @click="onClose">取消</el-button>
      <el-button type="primary" @click="onSubmit">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { uploadOss } from '@/api/system'
import { addIcon, delIcon } from '@/api/marker'
import { getIconData } from '@/utils/markerStyles'
import { mapGetters } from 'vuex'
export default {
  name: 'IconSelector',
  data () {
    return {
      isShow: false,
      iconGroup: 'STEREO',
      selectIconIndex: undefined,
      originId: undefined,
      loading: false,
      modulePath: {
        'STEREO': '/static/textures/icon/group1/',
        'FLAT': '/static/textures/icon/group2/',
        'PERSONAL': ''
      },
      fileList: [],
      canUpload: true
    }
  },
  computed: {
    ...mapGetters(['markerIcons']),

    groupIcons: function () {
      return this.markerIcons[this.iconGroup]
    },
    limitCount: function () {
      if (!this.markerIcons || !this.markerIcons.PERSONAL) {
        return 50
      } else {
        return 50 - this.markerIcons.PERSONAL.length
      }
    }
  },
  mounted () {},
  methods: {
    open (id) {
      this.isShow = true
      this.selectIconIndex = Number(id)
      this.originId = this.selectIconIndex
      this.getIconIndex(id)
    },
    clear () {
      this.selectIconIndex = undefined
      this.iconGroup = 'STEREO'
    },
    onClose () {
      this.clear()
      this.isShow = false
    },
    onSubmit () {
      this.$emit('selectedIcon', this.selectIconIndex)
      this.onClose()
    },
    getIconIndex (id) {
      const keys = Object.keys(this.markerIcons)
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i]
        const icons = this.markerIcons[key]
        for (let j = 0; j < icons.length; j++) {
          if (icons[j].id.toString() === id.toString()) {
            this.iconGroup = key
          }
        }
      }
    },
    getUrl (item) {
      return getIconData(item.id).url
    },
    onRemoveIcon (data) {
      this.$Delete({
        confirm: () => {
          delIcon({
            ids: [data.id]
          }).then(res => {
            if (res.code === 200) {
              this.$Message('success', res.msg || '删除成功！')
              this.$store.dispatch('getMarkerIcons')
              if (data.id === this.selectIconIndex) {
                this.selectIconIndex = this.originId
                this.getIconIndex(this.selectIconIndex)
              }
            }
          })
        },
        cancel: () => {
        }
      })
    },
    async onUploadIcon (file) {
      const res = await uploadOss(file.file)
      if (res && res.url) {
        this.fileList.push({
          'name': res.fileName,
          'url': res.url,
          'local': false,
          'module': 'PERSONAL'
        })
        // addIcon({
        //   'local': false,
        //   'module': 'PERSONAL',
        //   'name': res.fileName,
        //   'url': res.url
        // }).then(res => {
        //   if (res.code === 200) {
        //     this.$Message('success', res.msg || '操作成功！')
        //     this.$store.dispatch('getMarkerIcons')
        //   }
        // })
      }
    },
    beforeUpload (file) {
      const isPic = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 < 100
      if (!isPic) {
        this.$Message('warning', '上传图片只能是 JPG, PNG 格式!')
      } else if (!isLt2M) {
        this.$Message('warning', '上传图片大小不能超过 100 KB!')
      }
      return isPic && isLt2M
    },
    handleSuccess (response, file, fileList) {
      if (this.fileList.length < fileList.length) {
        return
      }
      this.canUpload = false
      if (this.markerIcons.PERSONAL && this.markerIcons.PERSONAL.length + fileList.length > 50) {
        this.$Message('warning', '自定义图标不能超过50个!')
        this.fileList = []
        this.$nextTick(() => {
          this.canUpload = true
        })
        return
      }
      addIcon({
        icons: this.fileList
      }).then(res => {
        if (res.code === 200) {
          this.$Message('success', res.msg || '操作成功！')
          this.$store.dispatch('getMarkerIcons')
          this.fileList = []
          this.canUpload = true
        }
      }).catch(res => {
        this.canUpload = true
      })
    }
  }
}
</script>

<style lang="scss">
.iconSelector {
  margin-top: 15vh;
  .content{
    width: 418px;
    text-align: left;
    .header{
      margin-bottom: 12px;
      margin-top: -9px;
      .el-radio-button{
        .el-radio-button__inner{
          background-color: unset;
          border: 1px solid #00A4F0;
          border-left: 0;
          padding: 7px 15px;
          width: 70px;
          color: #fff;
        }
        &:first-child{
          .el-radio-button__inner{
            border-radius: 15px 0 0 15px;
            border-left: 1px solid #00A4F0;
          }
        }
        &:last-child{
          .el-radio-button__inner{
            border-radius: 0 15px 15px 0;
          }
        }
      }
      .el-radio-button__orig-radio{
        &:checked{
          +.el-radio-button__inner{
            background-color: #00A4F0;
          }
        }
      }
    }
    .icon-frame{
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      height: 220px;
      background: #303132;
      border-radius: 6px;
      overflow-y: overlay;
      padding: 16px;
      .add-btn{
        width: 40px;
        height: 40px;
        margin: 4px;
        background: rgba(255, 255, 255, 0.1);
        border: 1px dashed #FFFFFF;
        opacity: 0.5;
        border-radius: 4px;
        color: #fff;
        text-align: center;
        font-size: 30px;
        &:hover {
          color: $hover-color;
          border-color:  $hover-color;
        }
      }
      .icon-item{
        margin: 4px;
        width: 40px;
        height: 40px;
        background: rgba(255, 255, 255, 0.1);
        border: 1px solid rgba(255, 255, 255, 0.2);
        // opacity: 0.2;
        border-radius: 4px;
        &.active{
          border: 1px solid #00A4F0;
        }
        .icon-image{
          text-align: center;
          line-height: 38px;
          img{
            max-width: 30px;
            max-height: 30px;
          }
        }
        .del-icon{
          position: relative;
          top: -50px;
          left: 25px;
          width: 0px;
          height: 0px;
        }
        .check{
          position: relative;
          left: 22px;
          bottom: 19px;
        }
      }
    }
  }
}
</style>
